(function () {
  'use strict';

  function wirePopover($rootScope, $timeout) {
      return {
          restrict: 'A',
          link: function (scope, element, attrs) {
            scope.contextId = attrs['wirePopover'];
            scope.togglePopoverClicked = function(event) {
                event.preventDefault();
                event.stopPropagation();
                scope.isPopoverClicked = !scope.isPopoverClicked;
                $rootScope.$broadcast('popoverOpened', { contextId: scope.contextId });
            };

            scope.closePopover = function() {
                if (scope.isPopoverClicked) {
                    delete scope.isPopoverClicked;
                }
            };
            
            scope.isPopoverOpen = function() {
                if(scope.isPopoverClicked) {
                    return true;
                } else if(false === scope.isPopoverClicked){
                    return false;
                }
            };

            $rootScope.$on('popoverOpened', function (event, args) {
                $timeout(function () {
                    if (args.contextId !== scope.contextId) {
                        scope.isPopoverClicked = false;
                    }
                });
            });
          }
      }
  }

  wirePopover.$inject = ['$rootScope', '$timeout'];

  angular.module('ecap.common').directive('wirePopover', wirePopover);
})();